import type { CrmTranslate } from './crm-copy';

export function createCrmCustomFieldsCopy(t: CrmTranslate) {
  return {
    customFields: {
      section: {
        title: t('crm.customFields.section.title'),
        description: t('crm.customFields.section.description'),
        readOnly: t('crm.customFields.section.readOnly'),
        empty: t('crm.customFields.section.empty'),
        loadFailed: t('crm.customFields.section.loadFailed'),
      },
      objects: {
        contacts: t('crm.customFields.objects.contacts'),
        companies: t('crm.customFields.objects.companies'),
        deals: t('crm.customFields.objects.deals'),
      },
      types: {
        text: t('crm.customFields.types.text'),
        number: t('crm.customFields.types.number'),
        currency: t('crm.customFields.types.currency'),
        date: t('crm.customFields.types.date'),
        datetime: t('crm.customFields.types.datetime'),
        select: t('crm.customFields.types.select'),
        multi_select: t('crm.customFields.types.multi_select'),
        relation: t('crm.customFields.types.relation'),
        file: t('crm.customFields.types.file'),
      },
      labels: {
        label: t('crm.customFields.labels.label'),
        object: t('crm.customFields.labels.object'),
        key: t('crm.customFields.labels.key'),
        keyHint: t('crm.customFields.labels.keyHint'),
        type: t('crm.customFields.labels.type'),
        options: t('crm.customFields.labels.options'),
        optionsHint: t('crm.customFields.labels.optionsHint'),
        currency: t('crm.customFields.labels.currency'),
        target: t('crm.customFields.labels.target'),
        required: t('crm.customFields.labels.required'),
        requiredBadge: t('crm.customFields.labels.requiredBadge'),
        formSection: t('crm.customFields.labels.formSection'),
        chooseOption: t('crm.customFields.labels.chooseOption'),
        chooseRecord: t('crm.customFields.labels.chooseRecord'),
        uploadFile: t('crm.customFields.labels.uploadFile'),
        replaceFile: t('crm.customFields.labels.replaceFile'),
        removeFile: t('crm.customFields.labels.removeFile'),
        uploading: t('crm.customFields.labels.uploading'),
        uploadFailed: t('crm.customFields.labels.uploadFailed'),
        download: t('crm.customFields.labels.download'),
        empty: t('crm.customFields.labels.empty'),
      },
      actions: {
        add: t('crm.customFields.actions.add'),
        create: t('crm.customFields.actions.create'),
        save: t('crm.customFields.actions.save'),
        cancel: t('crm.customFields.actions.cancel'),
        edit: t('crm.customFields.actions.edit'),
        delete: t('crm.customFields.actions.delete'),
        deleteTitle: t('crm.customFields.actions.deleteTitle'),
        confirmDelete: (label: string) =>
          t('crm.customFields.actions.confirmDelete', {
            values: { label },
          }),
      },
      validation: {
        required: (label: string) =>
          t('crm.customFields.validation.required', {
            values: { label },
          }),
        number: (label: string) =>
          t('crm.customFields.validation.number', {
            values: { label },
          }),
        datetime: (label: string) =>
          t('crm.customFields.validation.datetime', {
            values: { label },
          }),
        currency: (label: string, digits: number) =>
          t('crm.customFields.validation.currency', {
            values: { label, digits },
          }),
      },
      messages: {
        created: t('crm.customFields.messages.created'),
        updated: t('crm.customFields.messages.updated'),
        deleted: t('crm.customFields.messages.deleted'),
        saveFailed: t('crm.customFields.messages.saveFailed'),
        deleteFailed: t('crm.customFields.messages.deleteFailed'),
      },
    },
  };
}
